export enum HttpStatusCodes {
  OK = 200,
  Created = 201,
  NoContent = 204,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404
}
